//@flow
import * as React from 'react';
import { compose, lifecycle } from 'recompose';
import {
    getPjpMetricCard,
    computeMetricCardStatus
} from 'common/redux/selectors/pjpInsightsSelectors';
import { connect } from 'react-redux';
import { withRouter } from 'common/components/core/router';
import { type HOC } from 'common/types/flow-helpers';
import { type PjpMetricCardProps } from 'common/entity/pjpMaster/pjpDataTypes/insights/PjpMetricCardDataTypes';

type InjectedProps = { pjpMetricCard: PjpMetricCardProps };

export const createPjpMetricCardContainer: <TProps>(
    component: React.AbstractComponent<TProps>
) => HOC<TProps, InjectedProps> = compose(
    withRouter,
    connect((state, ownProps) => {
        const metricCardStatus = computeMetricCardStatus(state, ownProps);
        const isMetricLoading = metricCardStatus.isLoading;
        const metricHasData = metricCardStatus.hasData;
        let metricCardData;
        if (metricHasData) {
            metricCardData = getPjpMetricCard(state, ownProps);
        }
        const pjpMetricCard = {
            metricCard: metricCardData,
            isMetricLoading,
            metricHasData,
            currentPlanData: metricCardData?.chart.data?.currentPlanData,
            existingPlanData: metricCardData?.chart.data?.existingPlanData
        };
        return pjpMetricCard;
    }),
    lifecycle({
        fetchMetric(flushExisting) {
            const { fetchMetric, graph, existingBeatEnabled } = this.props;
            const { id, queries } = graph;
            const { metric, aggregationType, groupBy } = queries.get(0);
            fetchMetric(
                metric,
                aggregationType,
                groupBy,
                id,
                existingBeatEnabled,
                false,
                flushExisting || false
            );
        },

        componentDidMount() {
            this.fetchMetric();
        },

        componentDidUpdate(prevProps) {
            if (
                this.props.existingBeatEnabled !== prevProps.existingBeatEnabled
            ) {
                this.fetchMetric(true);
            }
        }
    })
);
